import { Base } from "ui/Scripts/source/framework/base";
import { IUserExternalSystem, UserExternalSystem } from "../externalSystem/userExternalSystem";
import { IUserIntraModule, UserIntraModule } from "../intraModule/userIntraModule";
import { IUserGroupListItem, UserGroupListItem } from "ui/Scripts/source/models/userGroup/userGroupListItem";
import { IUserEditItem, UserEditItem } from "./userEditItem";
import { CompanyMenuItem, ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { IUserTokenData, UserTokenData } from "./userTokenData";
import { CodeTitle, ICodeTitle } from "../common/codeTitle";

export interface IUserEdit {
    user: IUserEditItem;
    userGroups: IUserGroupListItem[];
    externalSystems: IUserExternalSystem[];
    intraModules: IUserIntraModule[];
    companies: ICompanyMenuItem[];
    companiesRequireUserGroups: ICodeTitle[];
    companyCanUseInstantMessages: boolean;
    minPasswordLength: number;
    tokenData: IUserTokenData;
    qrCodeLoginUrlTemplate: string;
}

export class UserEdit implements IUserEdit {
    user: UserEditItem;
    userGroups: UserGroupListItem[];
    externalSystems: UserExternalSystem[];
    intraModules: UserIntraModule[];
    companies: CompanyMenuItem[];
    companiesRequireUserGroups: CodeTitle[];
    companyCanUseInstantMessages: boolean;
    minPasswordLength: number;
    tokenData: UserTokenData;
    qrCodeLoginUrlTemplate: string;

    constructor();
    constructor(obj: IUserEdit);
    constructor(obj?: any) {
        this.user = new UserEditItem(obj?.user);
        this.userGroups = Base.getTypedArray(obj?.userGroups, UserGroupListItem);
        this.externalSystems = Base.getTypedArray(obj?.externalSystems, UserExternalSystem);
        this.intraModules = Base.getTypedArray(obj?.intraModules, UserIntraModule);
        this.companies = Base.getTypedArray(obj?.companies, CompanyMenuItem);
        this.companiesRequireUserGroups = Base.getTypedArray(obj?.companiesRequireUserGroups, CodeTitle);
        this.companyCanUseInstantMessages = obj && obj.companyCanUseInstantMessages || false;
        this.minPasswordLength = obj && obj.minPasswordLength || 0;
        this.tokenData = obj && obj.tokenData ? new UserTokenData(obj.tokenData) : null;
        this.qrCodeLoginUrlTemplate = obj && obj.qrCodeLoginUrlTemplate || "";
    }
}